var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_1752","data-name":"Ellipse 1752","cx":"10","cy":"10","r":"10","transform":"translate(1 1)","fill":"none","stroke":"#1cc54e","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_52730","data-name":"Path 52730","d":"M6,11.636l3.636,3.636L16.909,8","transform":"translate(-0.455 -0.636)","fill":"none","stroke":"#1cc54e","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]);
}

CircleCheck.defaultProps = {"id":"_13-Correct","data-name":"13-Correct","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
